(function () {
  function euro(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  function init() {
    var card = document.getElementById('BundleCard');
    if (!card) return;
    var discountPct = parseFloat(card.getAttribute('data-bundle-discount') || '15') / 100;
    var discountCode = (card.getAttribute('data-bundle-code') || '').trim();
    var checkboxes = card.querySelectorAll('[data-bundle-item]');
    var totalEl = card.querySelector('[data-bundle-total]');
    var baseEl = card.querySelector('[data-bundle-base]');
    var addBtn = document.getElementById('BundleAdd');

    // Shopify arrondit la remise ligne par ligne (au centime). On fait pareil
    // pour que le total affiché corresponde exactement à celui du panier.
    function recompute() {
      var baseCents = 0;
      var discCents = 0;
      checkboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var price = parseInt(cb.getAttribute('data-price'), 10) || 0;
        baseCents += price;
        discCents += Math.round(price * discountPct);
      });
      var totalCents = baseCents - discCents;
      totalEl.textContent = euro(totalCents);
      baseEl.textContent = discCents > 0 ? 'au lieu de ' + euro(baseCents) : '';
      addBtn.disabled = baseCents === 0;
    }

    checkboxes.forEach(function (cb) { cb.addEventListener('change', recompute); });
    recompute();

    // Applique réellement le code promo au panier.
    // /discount/<CODE> pose le cookie de réduction ; ?redirect=/cart.js
    // évite un rechargement de page et renvoie le panier à jour en JSON.
    function applyDiscount() {
      if (!discountCode) return Promise.resolve(null);
      return fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }

    function refreshCount(cart) {
      var pending = cart
        ? Promise.resolve(cart)
        : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      return pending.then(function (c) {
        var el = document.querySelector('.cart-count');
        if (el && c && typeof c.item_count !== 'undefined') el.textContent = c.item_count;
        return c;
      }).catch(function () { return null; });
    }

    addBtn.addEventListener('click', function () {
      var items = [];
      checkboxes.forEach(function (cb) {
        if (cb.checked) items.push({ id: cb.getAttribute('data-variant-id'), quantity: 1 });
      });
      if (!items.length || !window.themeRoutes) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Ajout…';
      fetch(window.themeRoutes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return applyDiscount(); })
        .then(function (cart) { return refreshCount(cart); })
        .then(function () {
          addBtn.textContent = 'Ajouté ✓';
          if (window.umFlashToast) {
            window.umFlashToast(discountCode ? 'Kit ajouté au panier — remise appliquée' : 'Kit ajouté au panier');
          }
          setTimeout(function () { addBtn.textContent = 'Ajouter le kit'; addBtn.disabled = false; }, 1800);
        })
        .catch(function () {
          addBtn.textContent = 'Erreur';
          addBtn.disabled = false;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
